import { gql, useMutation } from '@apollo/client'

export const CREATE_ARTIST = gql`
    mutation($input: ArtistCreate) {
        createArtist(input: $input) {
            id
            name
            label_id
            bio
            facebook_id
            gps_status
            opus_id
        }
    }
`

export const useCreateArtist = () => {
  const [mutate, { data, loading, error }] = useMutation(CREATE_ARTIST, {
    update(cache, {data}) {
      cache.modify({
        fields: {
          getArtists() {}
        }
      })
    }
  })

  return { mutate, data, loading, error }
}